import React from 'react';
import PropTypes from 'prop-types';
import { isSrcSetSupported } from '../../utils/featureDetection';
import { getSrcsetString } from '../../utils/srcSet';

export function ResponsiveImage(props) {
    const { photo, isClient, dataTn, ...otherProps } = props;
    const { masterOrZoomPath, largePath } = photo;
    const innerProps = {
        srcSet: null,
        src: null,
    };

    if (largePath) {
        innerProps.src = largePath;
    }

    if (masterOrZoomPath) {
        innerProps.srcSet = getSrcsetString(masterOrZoomPath);
    }

    /**
     * Safari has bug when loading dynamically injected img with srcset, need to remove src
     * so it doesn't load 2 images (1 from src and 1 from srcset)
     */
    if (isClient && isSrcSetSupported()) {
        innerProps.src = null;
    }

    return <img data-tn={dataTn} {...otherProps} {...innerProps} />;
}

ResponsiveImage.propTypes = {
    isClient: PropTypes.bool,
    photo: PropTypes.object.isRequired,
    type: PropTypes.string,
    width: PropTypes.number,
    quality: PropTypes.number,
    dataTn: PropTypes.string,
};
